module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Unidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contratoSelecionado.unidade.nome),
      expression: "contratoSelecionado.unidade.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.contratoSelecionado.unidade.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contratoSelecionado.unidade, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo do Contrato")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("tipoContrato")(_vm.contratoSelecionado.tipo)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data Inicial")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("dataFormatada")(_vm.contratoSelecionado.data_inicial)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data Final")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("dataFormatada")(_vm.contratoSelecionado.data_final)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Limite Geral")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("numberFormat")(_vm.contratoSelecionado.limite_geral, 2, ',', '.')
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-fa43fe0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administracao/contratos/cabecarioContrato.vue
// module id = 900
// module chunks = 0